// Ref: https://github.paypal.com/ConsumerWeb-UI/react-i18n/blob/master/src/createi18n.js
import { WorldReady, MessageFormat } from '@paypalcorp/worldready';

export default function (messages = {}, locale) {
  const i18n = {
    getIntlMessage(key, data) {
      const id = key.split(/\/|\./);
      let messageFormat;
      try {
        const worldReady = new WorldReady(locale);
        messageFormat = new MessageFormat(worldReady, {
          id,
        });
      } catch (error) {
        throw new ReferenceError(`Could not create messageformat for: ${key}`);
      }
      if (data) {
        return messageFormat.format(data);
      }
      return messageFormat.format();
    },

    message(key, data) {
      let message;

      if (!messages) {
        return '';
      }

      try {
        message = this.getIntlMessage(key, data);
      } catch (error) {
        if (window.console) {
          console.warn(error); // eslint-disable-line no-console
        }
      } finally {
        message = message || `☃${key}☃`;
      }

      return message;
    },

    link(key) {
      let message;

      if (!messages) {
        return '';
      }

      try {
        message = this.getIntlMessage(key);
      } catch (error) {
        message = '';
      } finally {
        message = message && message.trim();
      }

      return message;
    },
  };
  return i18n;
}
